import { render } from "./AposWidget.vue?vue&type=template&id=11457476"
import script from "./AposWidget.vue?vue&type=script&lang=js"
export * from "./AposWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"widget-type/ui/apos/components/AposWidget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "11457476"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('11457476', __exports__)) {
    api.reload('11457476', __exports__)
  }
  
  module.hot.accept("./AposWidget.vue?vue&type=template&id=11457476", () => {
    api.rerender('11457476', render)
  })

}


export default __exports__